import { applyMiddleware, combineReducers, compose,createStore,} from 'redux';
import thunk from 'redux-thunk';
import { AuthReducer } from './reducers/AuthReducer';
import ProfileReducer from './reducers/ProfileReducer';
import AccessKeyReducer from './reducers/AccessKeyReducer';
import TransactionSettingReducer from './reducers/TransactionSettingReducer';
import MerchantSettingReducer from './reducers/MerchantSettingReducer';
import KYCSettingReducer from "./reducers/KYCSettingReducer";
import MerchantReducer from "./reducers/MerchantReducer";
import MerchantTransSettingsReducer from "./reducers/MerchantTransSettingsReducer";
import MerchantBankAccountsReducer from "./reducers/MerchantBankAccountsReducer";
import MerchantKycReducer from "./reducers/MerchantKycReducer";
import IPAddressReducer from "./reducers/IPAddressReducer";
import MerchantFundRequestReducer from "./reducers/MerchantFundRequestReducer";
import MerchantBalanceReducer from "./reducers/MerchantBalanceReducer";
import MerchantPayoutReducer from "./reducers/MerchantPayoutReducer";
import MerchantCollectionsReducer from "./reducers/MerchantCollectionsReducer";
import MerchantReportReducer from "./reducers/MerchantReportReducer";
import MerchantTransactionComplaints from "./reducers/ComplaintsReducer";
import ApplicationMessagesReducer from "./reducers/ApplicationMessagesReducer";
import MerchantInvoiceReducer from "./reducers/MerchantInvoiceReducer";
import ProcessStatementReducer from "./reducers/ProcessStatementReducer";
import InvoiceDownloadJobsReducer from "./reducers/InvoiceDownloadJobsReducer";
const middleware = applyMiddleware(thunk);
const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const reducers = combineReducers({
    auth: AuthReducer,
    profile: ProfileReducer,
    accessKey: AccessKeyReducer,
    transactionSettings: TransactionSettingReducer,
    merchantSettings: MerchantSettingReducer,
    kycSettings: KYCSettingReducer,
    merchants:MerchantReducer,
    merchantBanks:MerchantBankAccountsReducer,
    merchantTransSettings:MerchantTransSettingsReducer,
    merchantKyc:MerchantKycReducer,
    IPAddress:IPAddressReducer,
    fundRequests:MerchantFundRequestReducer,
    merchantBalance : MerchantBalanceReducer,
    merchantPayout : MerchantPayoutReducer,
    merchantCollections : MerchantCollectionsReducer,
    merchantReports : MerchantReportReducer,
    merchantTransactionComplaints : MerchantTransactionComplaints,
    applicationMessages : ApplicationMessagesReducer,
    merchantInvoice : MerchantInvoiceReducer,
    processStatement : ProcessStatementReducer,
    invoiceDownloadJobs : InvoiceDownloadJobsReducer,
})
export const store = createStore(reducers,  composeEnhancers(middleware));
